// extracted by mini-css-extract-plugin
export default {"Tile":"Tile_Tile__88Lib","Date":"Tile_Date__8Yf81","Image":"Tile_Image__2R1d6","Title":"Tile_Title__AdUXC","Text":"Tile_Text__cvGjr"};